// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1hEud","title":"Images45_title__2k_fE","images":"Images45_images__eFMMf"};